"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;

var _util = require("../../../util");

const table = ({
  theme,
  cssProps
}) => {
  const {
    borderCollapse = 'collapse',
    borderSpacing = 0,
    layout = 'auto',
    variant = 'primary'
  } = cssProps;
  const tableVariant = theme.tables[variant];
  return {
    background: (0, _util.color)(theme, tableVariant.bg),
    borderCollapse,
    borderSpacing: (0, _util.spacing)(theme, borderSpacing),
    position: 'relative',
    tableLayout: layout,
    width: '100%',
    '& caption': { ...(0, _util.textStyle)(theme, 'meta'),
      captionSide: 'top',
      color: (0, _util.color)(theme, 'text.1'),
      padding: (0, _util.spacing)(theme, 'small'),
      textAlign: 'left'
    }
  };
};

exports.table = table;
//# sourceMappingURL=Table.style.js.map